import React, { Component } from 'react';

/*Material ui template */
import TextField from '@material-ui/core/TextField';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
export default class WorkPackageInfo extends Component {
  render() {
    return (
      <React.Fragment>

        <DialogTitle id="form-dialog-title">Work Package Information</DialogTitle>
         <DialogContent>
            <TextField
              required
              autoFocus
              id="name"
              name="Name"
              label="Name"
              fullWidth
              autoComplete="Name"
              value={this.props.workpackage.name || ''}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.workpackage.name}
              helperText={this.props.errores.workpackage.name}
            />
            <TextField
              style={{width: '100%', marginTop:'05%'}}
              id="description"
              label="Description"
              multiline
              rows="4"
              margin="normal"
              value={this.props.workpackage.description || ''}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.workpackage.description}
              helperText={this.props.errores.workpackage.description}
            />
            
          </DialogContent>
  </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/wbs/WorkPackageInfo.js